export const RedirectToEnrollStateSelector = 'enroll-state';

export const EnrollBgText = {
  title: 'Търговия с акции без комисиони',
  desc1: 'Регулаторите изискват от нас да ви зададем няколко въпроса, за да оценим вашия опит и знaния.',
  desc2: 'Следващата секция и търговията с акции е изцяло на английски език',
  continueBtn: 'ПРОДЪЛЖИ',
};
